/**
 * sets webpack publicPath on client side to runtime value
 * used in production bundle, in dev the path is set statically in webpack config
 */

// eslint-disable-next-line no-undef, camelcase, venom/no-prohibited-functions
__webpack_public_path__ = window.__PRELOADED_STATE__.config.publicPath; // compiled to __webpack_require__.p...
